/**
 * Uppercase initials for an avatar fallback: first + last word's first
 * letter ("Kerry Anne Buckley" -> "KB"). Blank input returns "?".
 */
export function initials(label: string): string {
  const words = label.trim().split(/\s+/).filter(Boolean)
  if (words.length === 0) return '?'
  const first = words[0][0] ?? ''
  const last = words.length > 1 ? (words[words.length - 1][0] ?? '') : ''
  return (first + last).toUpperCase()
}
